[
  {
    "key": "scout",
    "_tech": "requiresTech names the technology a unit needs before any city can build it (null: available from the start). obsoleteWith hides it from the build list once something better is known — it can still be kept, it just stops being offered.",
    "name": "Scout",
    "domain": "land",
    "glyph": "chevron",
    "attack": 0,
    "defence": 0,
    "hp": 10,
    "movement": 2,
    "sight": 2,
    "cost": 20,
    "upkeep": 1,
    "requiresTech": null,
    "obsoleteWith": "navigation",
    "abilities": [
      "ignore_terrain_cost",
      "ignore_zoc"
    ],
    "description": "Lightly equipped and sent far ahead. Reads ground that would slow an army to a crawl.",
    "_combat": "attack 0 cannot attack; defence 0 cannot defend and is captured by any enemy that enters its tile (ADR-0048). Strength is attack or defence times the defender's modifiers in rules.combat; each round the stronger side is likelier to land a hit of damagePerRound.",
    "upgradeTo": "explorer",
    "_upgradeTo": "What a unit can be upgraded to, for gold, in one of its owner's cities — the newest step along the chain its owner can build (ADR-0050). Null: nothing.",
    "_sea": "Sea units: capacity is how many land units it carries; coastal ships cannot enter deep water. Built only in cities beside the sea.",
    "_unique": "A unique unit belongs to one civilisation ('civilization') and replaces a standard unit ('replaces') for it alone: it needs the same technology and is made obsolete by the same one (ADR-0062)."
  },
  {
    "key": "worker",
    "name": "Worker",
    "domain": "land",
    "glyph": "disc",
    "attack": 0,
    "defence": 0,
    "hp": 10,
    "movement": 1,
    "sight": 1,
    "cost": 20,
    "upkeep": 1,
    "requiresTech": null,
    "obsoleteWith": null,
    "abilities": [
      "build_improvement"
    ],
    "populationCost": 0,
    "description": "Labourers with mattocks and baskets. Slow, defenceless, and the reason a hillside is worth more this century than last.",
    "upgradeTo": null
  },
  {
    "key": "settler",
    "name": "Settler",
    "domain": "land",
    "glyph": "disc",
    "attack": 0,
    "defence": 0,
    "hp": 10,
    "movement": 1,
    "sight": 1,
    "cost": 30,
    "upkeep": 1,
    "requiresTech": null,
    "obsoleteWith": null,
    "abilities": [
      "found_city"
    ],
    "_populationCost": "Building a settler takes people out of the city that builds it. The second brake on runaway growth, and what makes expansion a real decision.",
    "populationCost": 1,
    "description": "Families, tools and seed grain. Spends itself entirely on the founding of one city.",
    "upgradeTo": null
  },
  {
    "key": "warrior",
    "name": "Warrior",
    "domain": "land",
    "glyph": "shield",
    "attack": 1,
    "defence": 1,
    "hp": 10,
    "movement": 1,
    "sight": 1,
    "cost": 20,
    "upkeep": 1,
    "requiresTech": null,
    "obsoleteWith": "bronze_working",
    "abilities": [],
    "description": "Levied spearmen. Not much on open ground, and a great deal behind a wall.",
    "upgradeTo": "spearman"
  },
  {
    "key": "spearman",
    "name": "Spearman",
    "domain": "land",
    "glyph": "shield",
    "attack": 1,
    "defence": 2,
    "hp": 10,
    "movement": 1,
    "sight": 1,
    "cost": 25,
    "upkeep": 1,
    "requiresTech": "bronze_working",
    "obsoleteWith": "feudalism",
    "abilities": [],
    "description": "A bronze point on a long shaft, and the discipline to hold a line with it.",
    "upgradeTo": "pikeman"
  },
  {
    "key": "archer",
    "name": "Archer",
    "domain": "land",
    "glyph": "chevron",
    "attack": 2,
    "defence": 1,
    "hp": 10,
    "movement": 1,
    "sight": 1,
    "cost": 30,
    "upkeep": 1,
    "requiresTech": "archery",
    "obsoleteWith": "standing_army",
    "abilities": [],
    "description": "Strikes before the enemy can close. Poor company once they do.",
    "upgradeTo": "crossbowman"
  },
  {
    "key": "horseman",
    "name": "Horseman",
    "domain": "land",
    "glyph": "chevron",
    "attack": 2,
    "defence": 1,
    "hp": 10,
    "movement": 2,
    "sight": 1,
    "cost": 30,
    "upkeep": 1,
    "requiresTech": "horseback_riding",
    "obsoleteWith": "chivalry",
    "requiresResources": ["horses"],
    "abilities": [],
    "description": "Fast, light and hard to pin down. Scouts in peace, raiders in war.",
    "upgradeTo": "knight"
  },
  {
    "key": "chariot",
    "name": "Chariot",
    "domain": "land",
    "glyph": "chevron",
    "attack": 3,
    "defence": 1,
    "hp": 10,
    "movement": 2,
    "sight": 1,
    "cost": 40,
    "upkeep": 1,
    "requiresTech": "chariotry",
    "obsoleteWith": "chivalry",
    "requiresResources": ["horses"],
    "abilities": [],
    "description": "A driver, an archer and two horses: shock and speed on open ground.",
    "upgradeTo": "knight"
  },
  {
    "key": "swordsman",
    "name": "Swordsman",
    "domain": "land",
    "glyph": "shield",
    "attack": 3,
    "defence": 2,
    "hp": 10,
    "movement": 1,
    "sight": 1,
    "cost": 40,
    "upkeep": 1,
    "requiresTech": "iron_working",
    "obsoleteWith": "standing_army",
    "requiresResources": ["iron"],
    "abilities": [],
    "description": "Iron blades and a shield wall. The backbone of an early army.",
    "upgradeTo": "legion"
  },
  {
    "key": "pikeman",
    "name": "Pikeman",
    "domain": "land",
    "glyph": "shield",
    "attack": 1,
    "defence": 3,
    "hp": 10,
    "movement": 1,
    "sight": 1,
    "cost": 40,
    "upkeep": 1,
    "requiresTech": "feudalism",
    "obsoleteWith": "gunpowder",
    "requiresResources": ["iron"],
    "abilities": [],
    "description": "A hedge of long pikes that horsemen will not ride into.",
    "upgradeTo": "musketeer"
  },
  {
    "key": "knight",
    "name": "Knight",
    "domain": "land",
    "glyph": "chevron",
    "attack": 4,
    "defence": 2,
    "hp": 10,
    "movement": 2,
    "sight": 1,
    "cost": 60,
    "upkeep": 2,
    "requiresTech": "chivalry",
    "obsoleteWith": "metallurgy",
    "requiresResources": ["horses", "iron"],
    "abilities": [],
    "description": "Armoured, mounted and very expensive to lose.",
    "upgradeTo": "dragoon"
  },
  {
    "key": "musketeer",
    "name": "Musketeer",
    "domain": "land",
    "glyph": "shield",
    "attack": 3,
    "defence": 4,
    "hp": 10,
    "movement": 1,
    "sight": 1,
    "cost": 60,
    "upkeep": 2,
    "requiresTech": "gunpowder",
    "obsoleteWith": "rifling",
    "requiresResources": ["saltpetre"],
    "abilities": [],
    "description": "Slow to reload, but a volley breaks any charge.",
    "upgradeTo": "rifleman"
  },
  {
    "key": "dragoon",
    "name": "Dragoon",
    "domain": "land",
    "glyph": "chevron",
    "attack": 5,
    "defence": 3,
    "hp": 10,
    "movement": 2,
    "sight": 1,
    "cost": 70,
    "upkeep": 2,
    "requiresTech": "metallurgy",
    "obsoleteWith": "rifling",
    "requiresResources": ["horses", "saltpetre"],
    "abilities": [],
    "description": "Rides to the fight and dismounts to shoot.",
    "upgradeTo": "cavalry"
  },
  {
    "key": "explorer",
    "name": "Explorer",
    "domain": "land",
    "glyph": "chevron",
    "attack": 0,
    "defence": 0,
    "hp": 10,
    "movement": 3,
    "sight": 2,
    "cost": 30,
    "upkeep": 1,
    "requiresTech": "navigation",
    "obsoleteWith": null,
    "abilities": [
      "ignore_terrain_cost",
      "ignore_zoc"
    ],
    "description": "Maps, instruments and supplies for a season away. Covers rough country as if it were road.",
    "upgradeTo": null
  },
  {
    "key": "rifleman",
    "name": "Rifleman",
    "domain": "land",
    "glyph": "shield",
    "attack": 5,
    "defence": 6,
    "hp": 10,
    "movement": 1,
    "sight": 1,
    "cost": 80,
    "upkeep": 2,
    "requiresTech": "rifling",
    "obsoleteWith": "mass_production",
    "requiresResources": ["saltpetre"],
    "abilities": [],
    "description": "Accurate at long range and dug in, very hard to shift.",
    "upgradeTo": "infantry"
  },
  {
    "key": "infantry",
    "name": "Infantry",
    "domain": "land",
    "glyph": "shield",
    "attack": 6,
    "defence": 8,
    "hp": 10,
    "movement": 1,
    "sight": 1,
    "cost": 90,
    "upkeep": 2,
    "requiresTech": "mass_production",
    "obsoleteWith": "computers",
    "abilities": [],
    "description": "Conscripted in numbers, supplied by rail and armed from the factory.",
    "upgradeTo": "mech_infantry"
  },
  {
    "key": "tank",
    "name": "Tank",
    "domain": "land",
    "glyph": "chevron",
    "attack": 12,
    "defence": 6,
    "hp": 10,
    "movement": 3,
    "sight": 1,
    "cost": 150,
    "upkeep": 3,
    "requiresTech": "combustion",
    "obsoleteWith": null,
    "requiresResources": ["oil"],
    "abilities": [],
    "description": "Armour, tracks and a gun: the end of the trench.",
    "upgradeTo": null
  },
  {
    "key": "galley",
    "name": "Galley",
    "domain": "sea",
    "glyph": "ship",
    "attack": 1,
    "defence": 1,
    "hp": 10,
    "movement": 3,
    "sight": 2,
    "cost": 30,
    "upkeep": 1,
    "requiresTech": "seafaring",
    "obsoleteWith": "navigation",
    "abilities": [],
    "capacity": 2,
    "coastal": true,
    "upgradeTo": "caravel",
    "description": "Oars, a sail and room for a few soldiers. Hugs the shore — open ocean would swamp it."
  },
  {
    "key": "caravel",
    "name": "Caravel",
    "domain": "sea",
    "glyph": "ship",
    "attack": 1,
    "defence": 2,
    "hp": 10,
    "movement": 4,
    "sight": 2,
    "cost": 40,
    "upkeep": 1,
    "requiresTech": "navigation",
    "obsoleteWith": "magnetism",
    "abilities": [],
    "capacity": 3,
    "upgradeTo": "galleon",
    "description": "A small ship built for the open sea. The first that can cross an ocean.",
    "coastal": false
  },
  {
    "key": "galleon",
    "name": "Galleon",
    "domain": "sea",
    "glyph": "ship",
    "attack": 0,
    "defence": 2,
    "hp": 10,
    "movement": 4,
    "sight": 2,
    "cost": 50,
    "upkeep": 1,
    "requiresTech": "magnetism",
    "obsoleteWith": "combustion",
    "abilities": [],
    "capacity": 4,
    "upgradeTo": "transport",
    "description": "A deep-bellied carrier of armies and cargo. It does not fight; it needs escorting.",
    "coastal": false
  },
  {
    "key": "frigate",
    "name": "Frigate",
    "domain": "sea",
    "glyph": "ship",
    "attack": 4,
    "defence": 2,
    "hp": 10,
    "movement": 4,
    "sight": 2,
    "cost": 60,
    "upkeep": 1,
    "requiresTech": "magnetism",
    "obsoleteWith": "steam_power",
    "abilities": [],
    "capacity": 2,
    "upgradeTo": "ironclad",
    "description": "Two decks of guns under a cloud of sail. Fights at sea and carries a few marines besides.",
    "coastal": false
  },
  {
    "key": "ironclad",
    "name": "Ironclad",
    "domain": "sea",
    "glyph": "ship",
    "attack": 4,
    "defence": 4,
    "hp": 10,
    "movement": 4,
    "sight": 2,
    "cost": 70,
    "upkeep": 1,
    "requiresTech": "steam_power",
    "obsoleteWith": "industrialisation",
    "requiresResources": ["coal"],
    "abilities": [],
    "coastal": true,
    "upgradeTo": "cruiser",
    "description": "Steam and armour plate. Unsinkable by anything wooden, and unsafe anywhere out of sight of land.",
    "capacity": 0
  },
  {
    "key": "destroyer",
    "name": "Destroyer",
    "domain": "sea",
    "glyph": "ship",
    "attack": 6,
    "defence": 4,
    "hp": 10,
    "movement": 6,
    "sight": 3,
    "cost": 80,
    "upkeep": 1,
    "requiresTech": "combustion",
    "obsoleteWith": null,
    "requiresResources": ["oil"],
    "abilities": [],
    "description": "Fast, armed and ocean-going. Hunts other ships and guards the transports.",
    "upgradeTo": null,
    "capacity": 0,
    "coastal": false
  },
  {
    "key": "transport",
    "name": "Transport",
    "domain": "sea",
    "glyph": "ship",
    "attack": 0,
    "defence": 3,
    "hp": 10,
    "movement": 5,
    "sight": 2,
    "cost": 70,
    "upkeep": 1,
    "requiresTech": "combustion",
    "obsoleteWith": null,
    "requiresResources": ["oil"],
    "abilities": [],
    "capacity": 8,
    "description": "A steel hull for an army. Carries eight units across any ocean, and cannot fight.",
    "upgradeTo": null,
    "coastal": false
  },
  {
    "key": "catapult",
    "name": "Catapult",
    "domain": "land",
    "glyph": "siege",
    "attack": 4,
    "defence": 1,
    "hp": 10,
    "movement": 1,
    "sight": 1,
    "cost": 35,
    "upkeep": 1,
    "requiresTech": "mathematics",
    "obsoleteWith": "engineering",
    "abilities": ["siege"],
    "bombard": { "strength": 3, "range": 1, "shots": 2 },
    "description": "Timber, rope and a heavy stone. Walls and city defences do not stand in its way; anything that reaches it does.",
    "upgradeTo": "trebuchet"
  },
  {
    "key": "trebuchet",
    "name": "Trebuchet",
    "domain": "land",
    "glyph": "siege",
    "attack": 6,
    "defence": 1,
    "hp": 10,
    "movement": 1,
    "sight": 1,
    "cost": 50,
    "upkeep": 1,
    "requiresTech": "engineering",
    "obsoleteWith": "metallurgy",
    "abilities": ["siege"],
    "bombard": { "strength": 4, "range": 1, "shots": 3 },
    "description": "A counterweight the size of a house, throwing stones over any wall. Slow, and helpless up close.",
    "upgradeTo": "cannon"
  },
  {
    "key": "cannon",
    "name": "Cannon",
    "domain": "land",
    "glyph": "siege",
    "attack": 8,
    "defence": 1,
    "hp": 10,
    "movement": 1,
    "sight": 1,
    "cost": 65,
    "upkeep": 1,
    "requiresTech": "metallurgy",
    "obsoleteWith": "industrialisation",
    "requiresResources": ["iron", "saltpetre"],
    "abilities": ["siege"],
    "bombard": { "strength": 6, "range": 1, "shots": 3 },
    "description": "Cast bronze and black powder. Breaks walls, and can bombard the next tile without closing in.",
    "upgradeTo": "artillery"
  },
  {
    "key": "artillery",
    "name": "Artillery",
    "domain": "land",
    "glyph": "siege",
    "attack": 12,
    "defence": 2,
    "hp": 10,
    "movement": 1,
    "sight": 1,
    "cost": 90,
    "upkeep": 2,
    "requiresTech": "industrialisation",
    "obsoleteWith": "rocketry",
    "requiresResources": ["iron"],
    "abilities": ["siege"],
    "bombard": { "strength": 10, "range": 2, "shots": 3 },
    "description": "Rifled guns on iron carriages, firing two tiles over the heads of its own army.",
    "upgradeTo": "rocket_artillery"
  },
  {
    "key": "rocket_artillery",
    "name": "Rocket Artillery",
    "domain": "land",
    "glyph": "siege",
    "attack": 18,
    "defence": 3,
    "hp": 10,
    "movement": 2,
    "sight": 1,
    "cost": 130,
    "upkeep": 3,
    "requiresTech": "rocketry",
    "obsoleteWith": null,
    "requiresResources": ["oil"],
    "abilities": ["siege"],
    "bombard": { "strength": 16, "range": 2, "shots": 3 },
    "description": "Racks of rockets on a truck: a barrage two tiles away, and gone before the answer comes.",
    "upgradeTo": null
  },
  {
    "key": "crossbowman",
    "name": "Crossbowman",
    "domain": "land",
    "glyph": "chevron",
    "attack": 3,
    "defence": 2,
    "hp": 10,
    "movement": 1,
    "sight": 1,
    "cost": 35,
    "upkeep": 1,
    "requiresTech": "standing_army",
    "obsoleteWith": "invention",
    "abilities": [],
    "description": "A bow anyone can be drilled to use in a week, and that punches through bronze.",
    "upgradeTo": "longbowman"
  },
  {
    "key": "longbowman",
    "name": "Longbowman",
    "domain": "land",
    "glyph": "chevron",
    "attack": 4,
    "defence": 2,
    "hp": 10,
    "movement": 1,
    "sight": 1,
    "cost": 40,
    "upkeep": 1,
    "requiresTech": "invention",
    "obsoleteWith": "gunpowder",
    "abilities": [],
    "description": "Years of practice behind every arrow. The best soldier an iron-poor kingdom can field.",
    "upgradeTo": "musketeer"
  },
  {
    "key": "legion",
    "name": "Legion",
    "domain": "land",
    "glyph": "shield",
    "attack": 4,
    "defence": 2,
    "hp": 10,
    "movement": 1,
    "sight": 1,
    "cost": 45,
    "upkeep": 1,
    "requiresTech": "standing_army",
    "obsoleteWith": "gunpowder",
    "requiresResources": ["iron"],
    "abilities": [],
    "description": "Paid, drilled and armoured soldiers who march, dig and fight as one.",
    "upgradeTo": "musketeer"
  },
  {
    "key": "cavalry",
    "name": "Cavalry",
    "domain": "land",
    "glyph": "chevron",
    "attack": 8,
    "defence": 3,
    "hp": 10,
    "movement": 2,
    "sight": 1,
    "cost": 90,
    "upkeep": 2,
    "requiresTech": "rifling",
    "obsoleteWith": "combustion",
    "requiresResources": ["horses", "saltpetre"],
    "abilities": [],
    "description": "Carbines and sabres on horseback: the last and fastest of the mounted armies.",
    "upgradeTo": "tank"
  },
  {
    "key": "machine_gunner",
    "name": "Machine Gunner",
    "domain": "land",
    "glyph": "shield",
    "attack": 3,
    "defence": 9,
    "hp": 10,
    "movement": 1,
    "sight": 1,
    "cost": 85,
    "upkeep": 2,
    "requiresTech": "electricity",
    "obsoleteWith": "computers",
    "requiresResources": ["iron"],
    "abilities": [],
    "description": "One gun and a crew that can hold a line against a regiment. Poor at going forward.",
    "upgradeTo": "mech_infantry"
  },
  {
    "key": "mech_infantry",
    "name": "Mechanised Infantry",
    "domain": "land",
    "glyph": "shield",
    "attack": 6,
    "defence": 12,
    "hp": 10,
    "movement": 3,
    "sight": 1,
    "cost": 140,
    "upkeep": 3,
    "requiresTech": "computers",
    "obsoleteWith": null,
    "requiresResources": ["oil"],
    "abilities": [],
    "description": "Infantry that rides to battle in armour, and digs in wherever it stops.",
    "upgradeTo": null
  },
  {
    "key": "cruiser",
    "name": "Cruiser",
    "domain": "sea",
    "glyph": "ship",
    "attack": 8,
    "defence": 6,
    "hp": 10,
    "movement": 5,
    "sight": 2,
    "cost": 100,
    "upkeep": 2,
    "requiresTech": "industrialisation",
    "obsoleteWith": "mass_production",
    "requiresResources": ["coal"],
    "abilities": [],
    "description": "A fast steel warship with turreted guns, built to rule the sea lanes.",
    "upgradeTo": "battleship"
  },
  {
    "key": "battleship",
    "name": "Battleship",
    "domain": "sea",
    "glyph": "ship",
    "attack": 12,
    "defence": 10,
    "hp": 10,
    "movement": 5,
    "sight": 2,
    "cost": 160,
    "upkeep": 3,
    "requiresTech": "mass_production",
    "obsoleteWith": null,
    "requiresResources": ["oil"],
    "abilities": [],
    "bombard": { "strength": 10, "range": 2, "shots": 3 },
    "description": "The heaviest guns afloat. Bombards coasts two tiles inland and fears little at sea.",
    "upgradeTo": null
  },
  {
    "key": "fighter",
    "name": "Fighter",
    "domain": "air",
    "glyph": "plane",
    "attack": 4,
    "defence": 3,
    "hp": 10,
    "movement": 1,
    "sight": 2,
    "cost": 100,
    "upkeep": 2,
    "requiresTech": "flight",
    "obsoleteWith": "rocketry",
    "requiresResources": ["oil"],
    "abilities": ["intercept"],
    "airRange": 4,
    "description": "Fast, light and armed with machine guns. Based in a city, it meets enemy aircraft before they reach their target.",
    "upgradeTo": "jet_fighter"
  },
  {
    "key": "jet_fighter",
    "name": "Jet Fighter",
    "domain": "air",
    "glyph": "plane",
    "attack": 8,
    "defence": 6,
    "hp": 10,
    "movement": 1,
    "sight": 2,
    "cost": 150,
    "upkeep": 3,
    "requiresTech": "rocketry",
    "obsoleteWith": null,
    "requiresResources": ["oil"],
    "abilities": ["intercept"],
    "airRange": 6,
    "description": "Faster than sound and twice as deadly. The surest guard a city's sky can have.",
    "upgradeTo": null
  },
  {
    "key": "bomber",
    "name": "Bomber",
    "domain": "air",
    "glyph": "plane",
    "attack": 12,
    "defence": 3,
    "hp": 10,
    "movement": 1,
    "sight": 2,
    "cost": 140,
    "upkeep": 3,
    "requiresTech": "radio",
    "obsoleteWith": null,
    "requiresResources": ["oil"],
    "abilities": [],
    "airRange": 8,
    "description": "A heavy bomber guided by radio. Strikes far behind the lines, but cannot take a city and fears fighters.",
    "upgradeTo": null
  },
  {
    "key": "carrier",
    "name": "Aircraft Carrier",
    "domain": "sea",
    "glyph": "ship",
    "attack": 1,
    "defence": 8,
    "hp": 10,
    "movement": 5,
    "sight": 2,
    "cost": 160,
    "upkeep": 3,
    "requiresTech": "radio",
    "obsoleteWith": null,
    "requiresResources": ["oil"],
    "abilities": [],
    "airCapacity": 4,
    "description": "A floating airfield for four aircraft. Its planes strike from wherever it sails, and go down with it if it sinks.",
    "upgradeTo": null
  },
  {
    "key": "elamite_chariot",
    "name": "Elamite Chariot",
    "domain": "land",
    "glyph": "chevron",
    "attack": 3,
    "defence": 2,
    "hp": 10,
    "movement": 2,
    "sight": 1,
    "cost": 40,
    "upkeep": 1,
    "requiresTech": "chariotry",
    "obsoleteWith": "chivalry",
    "requiresResources": ["horses"],
    "abilities": [],
    "description": "Heavy four-horse chariots of the Elamite kings, as Assyria carved them. Tougher than an ordinary chariot.",
    "upgradeTo": "knight",
    "civilization": "elam",
    "replaces": "chariot"
  },
  {
    "key": "taseti_archer",
    "name": "Ta-Seti Archer",
    "domain": "land",
    "glyph": "chevron",
    "attack": 3,
    "defence": 2,
    "hp": 10,
    "movement": 1,
    "sight": 1,
    "cost": 30,
    "upkeep": 1,
    "requiresTech": "archery",
    "obsoleteWith": "standing_army",
    "abilities": [],
    "description": "Nubia was the Land of the Bow; its archers aimed for the eye. Stronger and steadier than ordinary archers.",
    "upgradeTo": "crossbowman",
    "civilization": "nubia",
    "replaces": "archer"
  },
  {
    "key": "hwarang",
    "name": "Hwarang",
    "domain": "land",
    "glyph": "shield",
    "attack": 3,
    "defence": 3,
    "hp": 10,
    "movement": 1,
    "sight": 1,
    "cost": 40,
    "upkeep": 1,
    "requiresTech": "iron_working",
    "obsoleteWith": "standing_army",
    "requiresResources": ["iron"],
    "abilities": [],
    "description": "The Flower Youth of Silla, schooled in arms, verse and loyalty. As hard to break as to face.",
    "upgradeTo": "legion",
    "civilization": "silla",
    "replaces": "swordsman"
  },
  {
    "key": "quinquereme",
    "name": "Quinquereme",
    "domain": "sea",
    "glyph": "ship",
    "attack": 2,
    "defence": 2,
    "hp": 10,
    "movement": 3,
    "sight": 2,
    "cost": 30,
    "upkeep": 1,
    "requiresTech": "seafaring",
    "obsoleteWith": "navigation",
    "abilities": [],
    "capacity": 2,
    "coastal": true,
    "upgradeTo": "caravel",
    "description": "Carthage's five-banked warship, built to a pattern so the fleet could be replaced in weeks. Fights better than a galley.",
    "civilization": "carthage",
    "replaces": "galley"
  },
  {
    "key": "andean_slinger",
    "name": "Andean Slinger",
    "domain": "land",
    "glyph": "shield",
    "attack": 2,
    "defence": 1,
    "hp": 10,
    "movement": 1,
    "sight": 1,
    "cost": 20,
    "upkeep": 1,
    "requiresTech": null,
    "obsoleteWith": "bronze_working",
    "abilities": [],
    "description": "A woven sling and a pouch of stones: the oldest weapon of the Andes, deadly at range. Hits harder than a warrior.",
    "upgradeTo": "spearman",
    "civilization": "tiwanaku",
    "replaces": "warrior"
  },
  {
    "key": "shotelai",
    "name": "Shotelai",
    "domain": "land",
    "glyph": "shield",
    "attack": 3,
    "defence": 3,
    "hp": 10,
    "movement": 1,
    "sight": 1,
    "cost": 45,
    "upkeep": 1,
    "requiresTech": "feudalism",
    "obsoleteWith": "gunpowder",
    "requiresResources": ["iron"],
    "abilities": [],
    "description": "Aksumite infantry with the curved shotel that hooks round a shield. Can attack as well as hold.",
    "upgradeTo": "musketeer",
    "civilization": "aksum",
    "replaces": "pikeman"
  },
  {
    "key": "war_elephant",
    "name": "War Elephant",
    "domain": "land",
    "glyph": "chevron",
    "attack": 5,
    "defence": 3,
    "hp": 10,
    "movement": 1,
    "sight": 1,
    "cost": 60,
    "upkeep": 2,
    "requiresTech": "chivalry",
    "obsoleteWith": "metallurgy",
    "requiresResources": ["horses", "iron"],
    "abilities": [],
    "description": "The Khmer kings rode to war on elephants, as the Bayon's walls show. Slow, but very hard to stop.",
    "upgradeTo": "dragoon",
    "civilization": "khmer",
    "replaces": "knight"
  },
  {
    "key": "druzhina",
    "name": "Druzhina",
    "domain": "land",
    "glyph": "chevron",
    "attack": 3,
    "defence": 2,
    "hp": 10,
    "movement": 2,
    "sight": 1,
    "cost": 30,
    "upkeep": 1,
    "requiresTech": "horseback_riding",
    "obsoleteWith": "chivalry",
    "requiresResources": ["horses"],
    "abilities": [],
    "description": "The prince's armed retinue, mailed and mounted. Stronger than ordinary horsemen.",
    "upgradeTo": "knight",
    "civilization": "rus",
    "replaces": "horseman"
  }
]
